import React, { useEffect } from "react";
import WorkflowFromScratch from "./workflow-from-scratch";
import Header from "../common/header/Header";
import wlGraphic from '../../assets/images/workload-graphic.png';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getTrails } from "../../reducer/slices/trial/get-trial-slice";


const Workflow = () => {
  const dispatch = useDispatch();
  const trailData = useSelector((state) => state.trails.data.items);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getTrails({}));
  }, []);
  

  const handleSelectChange = (event) => {
    const selectedTrialID = event.target.value;
    if (selectedTrialID) {
      navigate(`/workflow/${selectedTrialID}`);
    }
  };

  return (
    <>
      <Header headertitle="Trial Hub" />
      <div className="flex flex-columnflex flex-col items-center text-center mt-20 my-5 item-center">
        <img src={wlGraphic} alt="" />
        <p className="mt-10 mb-8 text-md text-gray-800">
          Create a New Trial or Edit an Existing one
        </p>

        <div className="flex gap-2">
          <Link
            to="/create-Trial"
            className="px-5 py-1 text-base rounded-md border primary_btn transition-all items-center duration-500 flex"
          >
            <svg
              className="h-5 w-5 text-white-500"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" />
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
            Create New Workflow
          </Link>

          <select
            className="px-5 py-1 text-base rounded-md border secondary_btn transition-all duration-500"
            onChange={handleSelectChange}
          >
            <option value="">Edit an Existing Workflow</option>
            {trailData &&
              trailData.length > 0 &&
              trailData.map((item) => (
                <option key={item.trialID} value={item.trialID}>
                  {item.trialName}
                </option>
              ))}
          </select>
        </div>
      </div>
    </>
  );
};

export default Workflow;
